import { StyledButton, StyledForm } from '@/components/styles'
import { FormField, AttributionHiddenFields } from '@/components'
import { useForm, FormContext } from 'react-hook-form'
import { useState, useRef } from 'react'
import { normalizePhone, regExp } from '@/lib/config'
import { useModal } from './Modal'
import api from '@/lib/api'
import { useTranslation } from "react-i18next";
import { getAttributionFields } from '@/lib/attribution'

export default function ConsultationForm() {
  const formMethods = useForm()
  const { handleSubmit, reset } = formMethods
  const { t } = useTranslation("global");

  const [status, setStatus] = useState({
    success: false,
    loading: false,
    error: false,
  })
  const errorInput = useRef()

  const handleError = () => {
    setStatus(prevStatus => ({ ...prevStatus, error: true }))
    errorInput.current.focus()
  }

  const onFormSubmit = async data => {
    setStatus(prevStatus => ({ ...prevStatus, loading: true }))

    try {
      const resp = await api.consultationCreate({
        ...data,
        phone: normalizePhone(data.phone),
        ...getAttributionFields(),
      })
      if (resp.result === 'success') {
        reset()
        setStatus(prevStatus => ({ ...prevStatus, loading: false, success: true }))
      } else {
        handleError()
      }
    } catch (error) {
      handleError()
    }
  }

  return status.success ? (
    <Success />
  ) : (
    <FormContext {...formMethods}>
      <StyledForm
        as="form"
        action="/"
        onSubmit={handleSubmit(onFormSubmit)}
        modal
        autoComplete="off"
      >
        <AttributionHiddenFields />
        <StyledForm.Title>{t('consultationForm.title')}</StyledForm.Title>

        {status.error && (
          <StyledForm.Error ref={errorInput} value="Ошибка сервера, попробуйте позже" readOnly />
        )}

        <StyledForm.Block>
          <StyledForm.Row>
            <StyledForm.Item>
              <FormField label={t('consultationForm.name')} name="name" validateRules={{ required: true }} autoFocus />
            </StyledForm.Item>

            <StyledForm.Item>
              <FormField
                label={t('consultationForm.phone')}
                name="phone"
                type="tel"
                inputmode="tel"
                placeholder="+"
                validateRules={{ required: true, pattern: regExp.phone }}
              />
            </StyledForm.Item>
          </StyledForm.Row>

          <StyledForm.Row>
            <StyledForm.Item>
              <FormField inputAs="textarea" label={t('consultationForm.comment')} name="comment" />
            </StyledForm.Item>
          </StyledForm.Row>
        </StyledForm.Block>

        <StyledForm.Submit>
          <StyledButton type="submit" disabled={status.loading} isLoading={status.loading}>
          {t('consultationForm.submit')}
            <StyledButton.Loader />
          </StyledButton>
        </StyledForm.Submit>
      </StyledForm>
    </FormContext>
  )
}

function Success() {
  const modal = useModal()
  const { closeModal } = modal
  const { t } = useTranslation("global");

  return (
    <StyledForm as="div" modal>
      <StyledForm.Title centered>{t('consultationForm.thanks.title')}</StyledForm.Title>
      <StyledForm.Desc centered>{t('consultationForm.thanks.desc')}</StyledForm.Desc>
      <StyledForm.Submit>
        <StyledButton type="button" onClick={closeModal}>
        {t('consultationForm.thanks.button')}
        </StyledButton>
      </StyledForm.Submit>
    </StyledForm>
  )
}
